import React from 'react';
import PageHeader from '../components/PageHeader';
import { MapPin, Clock, Shirt, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';

const LocationPage: React.FC = () => {
  return (
    <div className="min-h-screen py-12 px-4">
      <PageHeader 
        title="Local do Evento" 
        subtitle="Informações sobre o local e horário da cerimônia e recepção"
      />
      
      <div className="container mx-auto max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <motion.div
            className="bg-white rounded-lg shadow-md overflow-hidden"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="h-48 overflow-hidden">
              <img 
                src="https://aqyqcsnugiyfjlpobzux.supabase.co/storage/v1/object/sign/valorizando-dados-empresa/image_config/igreja.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZTNjZTg2ZS04MWIyLTRmMmYtOTdiMy0yNjNmMGY0ZGM1YzAiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJ2YWxvcml6YW5kby1kYWRvcy1lbXByZXNhL2ltYWdlX2NvbmZpZy9pZ3JlamEuanBnIiwiaWF0IjoxNzQ4NzU0ODA4LCJleHAiOjE3ODAyOTA4MDh9.3PT1ZcRXntkdHxAVPozG-dZIzXWc4tsTibYa2YTu8zo" 
                alt="Igreja" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-6">
              <h3 className="text-xl font-playfair font-medium text-wedding-blue-800 mb-4">
                Cerimônia
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Paróquia Nossa Senhora do Perpétuo Socorro</p>
                    <p className="text-gray-600">R. Dom Pedro II, 355 - Centro</p>
                    <p className="text-gray-600">Capanema, PA</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <Clock className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Horário</p>
                    <p className="text-gray-600">02 de Agosto de 2025</p>
                    <p className="text-gray-600">Início às 9:30</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Shirt className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Dress Code</p>
                    <p className="text-gray-600">Esporte Fino</p>
                  </div>
                </div>

                <a
                  href="https://www.google.com.br/maps/place/Par%C3%B3quia+Nossa+Senhora+do+Perp%C3%A9tuo+Socorro/@-1.1950072,-47.1831534,17z/data=!3m1!4b1!4m6!3m5!1s0x92af6c50c83ed433:0xb8835822141416c1!8m2!3d-1.1950126!4d-47.1805785!16s%2Fg%2F1vc_rfh1?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full px-4 py-2 bg-wedding-blue-600 text-white rounded-md hover:bg-wedding-blue-700 transition-colors mt-4"
                >
                  <ExternalLink size={18} className="mr-2" />
                  Ver no Google Maps
                </a>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            className="bg-white rounded-lg shadow-md overflow-hidden"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="h-48 overflow-hidden">
              <img 
                src="https://aqyqcsnugiyfjlpobzux.supabase.co/storage/v1/object/sign/valorizando-dados-empresa/image_config/sitio.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV82ZTNjZTg2ZS04MWIyLTRmMmYtOTdiMy0yNjNmMGY0ZGM1YzAiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJ2YWxvcml6YW5kby1kYWRvcy1lbXByZXNhL2ltYWdlX2NvbmZpZy9zaXRpby5qcGciLCJpYXQiOjE3NDg3NTQ4MzAsImV4cCI6MTc4MDI5MDgzMH0.O5Vs4guYFZKq-fqgdK6PKpCDFockK2V1oHteUJzYbqM" 
                alt="Sitio Nosso Lugar" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-6">
              <h3 className="text-xl font-playfair font-medium text-wedding-blue-800 mb-4">
                Recepção
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Sitio Nosso Lugar</p>
                    <p className="text-gray-600">ramal do pequiá, 68647-000</p>
                    <p className="text-gray-600">Tracuateua, PA</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <Clock className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Horário</p>
                    <p className="text-gray-600">02 de Agosto de 2025</p>
                    <p className="text-gray-600">Início às 12:00</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <Shirt className="w-5 h-5 text-wedding-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Dress Code</p>
                    <p className="text-gray-600">Roupas leves e roupas de banho</p>
                    <p className="text-xs text-gray-500">Traje de banho com modéstia</p>
                  </div>
                </div>

                <a
                  href="https://www.google.com.br/maps/place/Sitio+Nosso+Lugar/@-1.1389176,-46.9678771,17z/data=!3m1!4b1!4m6!3m5!1s0x92af19c9f0d36633:0x4df4b7afb66ebf9a!8m2!3d-1.138923!4d-46.9632637!16s%2Fg%2F11g8whxq5j?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full px-4 py-2 bg-wedding-blue-600 text-white rounded-md hover:bg-wedding-blue-700 transition-colors mt-4"
                >
                  <ExternalLink size={18} className="mr-2" />
                  Ver no Google Maps
                </a>
              </div>
            </div>
          </motion.div>
        </div>
        
        <div className="bg-wedding-beige-100 rounded-lg p-6 text-center">
          <h3 className="text-xl font-playfair font-medium text-wedding-blue-800 mb-4">
            Estacionamento
          </h3>
          
          <p className="text-gray-700 mb-2">
            Estacionamento gratuito disponível no local da recepção.
          </p>
          
          <p className="text-gray-700">
            Para a cerimônia, recomendamos utilizar os estacionamentos próximos à igreja ou serviços de transporte por aplicativo.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LocationPage;